/**
 * SA demo-tenant status query hook.
 *
 * Endpoint: GET /admin/demo/status
 *
 * Powers the SA demo page's "current state" pane — shows the last reset
 * timestamp, the current admin email (so the SA can pre-fill the form
 * with the value already in production), and the live candidate +
 * ranking counts. Returns ``exists=false`` when no demo tenant exists.
 */
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

interface DemoStatusResponse {
  exists: boolean;
  last_reset_at: string | null;
  admin_email: string | null;
  candidate_count: number;
  ranking_count: number;
}

export function useDemoStatus() {
  return useQuery<DemoStatusResponse, ApiError>({
    queryKey: ["admin", "demo", "status"],
    queryFn: async () => {
      const r = await apiClient.get<DemoStatusResponse>("/admin/demo/status");
      return r.data;
    },
  });
}
